import React, { memo, useState, useRef } from 'react'
import { TextField, MenuItem, InputAdornment, IconButton } from '@mui/material'
import { faEye, faEyeSlash, faQrcode } from '@fortawesome/pro-duotone-svg-icons'

import { INPUT_PASSWORD, INPUT_TEXT } from '../../../constants/input'
import FaIcon from '../faIcon/FaIcon'

const CustomTextField = ({
  type,
  onChange,
  onKeyDown,
  value,
  label,
  help,
  success,
  error,
  eyePassword,
  multiLine,
  maxLength,
  positiveNumber,
  qrCodeEnabled,
  onQrCodeClick,
  isDropdown,
  options,
  endIcon,
  startIcon,
  ...restProps
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const textAreaRef = useRef(null)

  const handleEyePassword = () => {
    setShowPassword((prev) => !prev)
  }

  const handleInputChange = (e) => {
    if (maxLength && e.target.value.length > maxLength) return
    onChange && onChange(e.target.value)
  }

  const handleKeyDown = (e) => {
    if (positiveNumber && ['-', 'e', '+', 'E', '.'].includes(e.key)) {
      e.preventDefault()
    }
    onKeyDown && onKeyDown(e)
  }

  const inputType = eyePassword
    ? showPassword
      ? INPUT_TEXT
      : INPUT_PASSWORD
    : type || INPUT_TEXT

  return (
    <TextField
      variant='outlined'
      fullWidth
      select={isDropdown}
      type={inputType}
      value={value}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      label={label}
      multiline={multiLine}
      inputRef={multiLine ? textAreaRef : null}
      error={!!error}
      helperText={error || success || help || ''}
      slotProps={{
        inputLabel: { shrink: true },
        formHelperText: {
          sx: {
            color: success && 'success.main'
          }
        },
        input: {
          startAdornment: startIcon && (
            <InputAdornment position='start'>{startIcon}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              {qrCodeEnabled && (
                <IconButton
                  onClick={onQrCodeClick}
                  edge='end'
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  sx={{ py: 0 }}
                >
                  <FaIcon icon={faQrcode} size='sm' />
                </IconButton>
              )}
              {eyePassword && (
                <IconButton onClick={handleEyePassword} edge='end'>
                  <FaIcon icon={showPassword ? faEyeSlash : faEye} size='sm' />
                </IconButton>
              )}
              {endIcon}
            </InputAdornment>
          )
        }
      }}
      autoComplete='off'
      {...restProps}
    >
      {isDropdown &&
        options.map(({ value, label }, index) => (
          <MenuItem key={index} value={value}>
            {label}
          </MenuItem>
        ))}
    </TextField>
  )
}

export default memo(CustomTextField)
